/* =========================================================
   J'ADORE — Menu (mega desktop + drawer mobile)
   ZABIEGI / BONY: kafle ze zdjeciem (categories[]).
   DERMOKOSMETYKI: rail obszarow (filtr) + siatka LOGOTYPOW marek (grafit
     w spoczynku, kolor po najechaniu; klik -> podstrona marki) + pasek zaufania.
   Dane: window.__JADORE_MENU (snippet jadore-megamenu-data).
   Nieinwazyjne: brak danych -> natywna nawigacja dziala normalnie.
   ========================================================= */
(function () {
  if (window.__JADORE_MENU_INIT__) return;
  window.__JADORE_MENU_INIT__ = true;

  /* 21.09.2026: adresy w danych menu sa bez przedrostka jezyka ("/pages/marki"), wiec
     klientka na /it/... po kazdym kliknieciu w megamenu ladowala na polskiej wersji.
     Shopify.routes.root to "/it/" (albo "/" dla polskiego) — przepuszczamy przez niego
     wszystkie adresy wewnetrzne, raz, zanim menu je odczyta. */
  /* Napisy menu w 13 jezykach; 21.09.2026 przeniesione na poziom modulu, bo uzywa ich tez
     menu na komputerze, i dolozone T[11..15] (dotad wpisane po polsku na sztywno). */
  var NAPISY = {
    pl: ['Szukaj produktu lub marki', 'Wybierz markę', 'Wszystkie marki', 'Szukaj', 'Wybierz po potrzebie', 'Rodzaj produktu', 'Kup bon', 'Prezent na zabiegi i kosmetyki', 'Zabiegi', 'Wszystkie zabiegi', 'Strona główna', 'Cały sklep · filtruj i kupuj', '100% oryginalnych kosmetyków', 'Możliwość konsultacji z kosmetologiem', 'Wyselekcjonowane marki', 'Wszystkie marki — dowiedz się więcej →', 'Nasze zabiegi', 'Pomysł na prezent', 'Bony specjalne', 'Pomysł na event', 'Beauty News', 'Nasze instytuty'],
    en: ['Search products or brands', 'Choose a brand', 'All brands', 'Search', 'Choose by need', 'Product type', 'Buy a gift card', 'A gift for treatments and cosmetics', 'Treatments', 'All treatments', 'Home page', 'Entire shop · filter and buy', '100% original cosmetics', 'Possibility of consultation with a cosmetologist', 'Selected brands', 'All brands — learn more →', 'Our treatments', 'Gift idea', 'Special vouchers', 'Event idea', 'Beauty News', 'Our institutes'],
    de: ['Produkt oder Marke suchen', 'Marke wählen', 'Alle Marken', 'Suchen', 'Nach Bedarf wählen', 'Produktart', 'Gutschein kaufen', 'Geschenk für Behandlungen und Kosmetik', 'Behandlungen', 'Alle Behandlungen', 'Startseite', 'Gesamter Shop · filtern und kaufen', '100% Originalkosmetik', 'Möglichkeit der Beratung durch eine Kosmetologin', 'Ausgewählte Marken', 'Alle Marken — mehr erfahren →', 'Unsere Behandlungen', 'Geschenkidee', 'Spezielle Gutscheine', 'Event-Idee', 'Beauty News', 'Unsere Institute'],
    es: ['Buscar producto o marca', 'Elige una marca', 'Todas las marcas', 'Buscar', 'Elige según tu necesidad', 'Tipo de producto', 'Comprar un bono', 'Regalo para tratamientos y cosmética', 'Tratamientos', 'Todos los tratamientos', 'Página principal', 'Toda la tienda · filtra y compra', '100% cosméticos originales', 'Posibilidad de consulta con cosmetólogo', 'Marcas seleccionadas', 'Todas las marcas — descubre más →', 'Nuestros tratamientos', 'Idea para regalar', 'Bonos especiales', 'Idea para un evento', 'Beauty News', 'Nuestros institutos'],
    fr: ['Rechercher un produit ou une marque', 'Choisir une marque', 'Toutes les marques', 'Rechercher', 'Choisir par besoin', 'Type de produit', 'Acheter un bon', 'Un cadeau pour soins et cosmétiques', 'Soins', 'Tous les soins', 'Accueil', 'Toute la boutique · filtrez et achetez', '100% de cosmétiques originaux', 'Possibilité de consultation avec une cosmétologue', 'Marques sélectionnées', 'Toutes les marques — en savoir plus →', 'Nos soins', 'Idée cadeau', 'Bons spéciaux', 'Idée d\'événement', 'Beauty News', 'Nos instituts'],
    it: ['Cerca prodotto o marca', 'Scegli un marchio', 'Tutti i marchi', 'Cerca', 'Scegli per esigenza', 'Tipo di prodotto', 'Acquista un buono', 'Un regalo per trattamenti e cosmetici', 'Trattamenti', 'Tutti i trattamenti', 'Pagina principale', 'Tutto il negozio · filtra e acquista', '100% cosmetici originali', 'Possibilità di consulenza con la cosmetologa', 'Marche selezionate', 'Tutte le marche — scopri di più →', 'I nostri trattamenti', 'Idea regalo', 'Buoni speciali', 'Idea per un evento', 'Beauty News', 'I nostri istituti'],
    nl: ['Zoek product of merk', 'Kies een merk', 'Alle merken', 'Zoeken', 'Kies op behoefte', 'Productsoort', 'Koop een cadeaubon', 'Cadeau voor behandelingen en cosmetica', 'Behandelingen', 'Alle behandelingen', 'Homepage', 'Hele winkel · filter en koop', '100% originele cosmetica', 'Mogelijkheid tot consult met een schoonheidsspecialist', 'Geselecteerde merken', 'Alle merken — meer informatie →', 'Onze behandelingen', 'Cadeau-idee', 'Speciale bonnen', 'Idee voor een event', 'Beauty News', 'Onze instituten'],
    pt: ['Pesquisar produto ou marca', 'Escolha uma marca', 'Todas as marcas', 'Pesquisar', 'Escolha pela necessidade', 'Tipo de produto', 'Comprar um vale', 'Presente para tratamentos e cosmética', 'Tratamentos', 'Todos os tratamentos', 'Página inicial', 'Toda a loja · filtre e compre', '100% cosméticos originais', 'Possibilidade de consulta com cosmetologista', 'Marcas selecionadas', 'Todas as marcas — saiba mais →', 'Os nossos tratamentos', 'Ideia para presente', 'Vales especiais', 'Ideia para evento', 'Beauty News', 'Os nossos institutos'],
    sv: ['Sök produkt eller märke', 'Välj märke', 'Alla märken', 'Sök', 'Välj efter behov', 'Produkttyp', 'Köp presentkort', 'Present för behandlingar och hudvård', 'Behandlingar', 'Alla behandlingar', 'Startsida', 'Hela butiken · filtrera och köp', '100% äkta kosmetika', 'Möjlighet till konsultation med hudterapeut', 'Utvalda varumärken', 'Alla varumärken — läs mer →', 'Våra behandlingar', 'Presenttips', 'Specialpresentkort', 'Idé för event', 'Beauty News', 'Våra institut'],
    nb: ['Søk etter produkt eller merke', 'Velg merke', 'Alle merker', 'Søk', 'Velg etter behov', 'Produkttype', 'Kjøp gavekort', 'Gave til behandlinger og hudpleie', 'Behandlinger', 'Alle behandlinger', 'Hjemmeside', 'Hele butikken · filtrer og kjøp', '100 % originale kosmetikkprodukter', 'Mulighet for konsultasjon med kosmetolog', 'Utvalgte merker', 'Alle merker — les mer →', 'Våre behandlinger', 'Gaveidé', 'Spesialtilbud', 'Idé for arrangement', 'Beauty News', 'Våre institutter'],
    el: ['Αναζήτηση προϊόντος ή μάρκας', 'Επιλέξτε μάρκα', 'Όλες οι μάρκες', 'Αναζήτηση', 'Επιλογή κατά ανάγκη', 'Τύπος προϊόντος', 'Αγορά δωροκάρτας', 'Δώρο για θεραπείες και καλλυντικά', 'Θεραπείες', 'Όλες οι θεραπείες', 'Αρχική σελίδα', 'Όλο το κατάστημα · φιλτράρετε και αγοράστε', '100% αυθεντικά καλλυντικά', 'Δυνατότητα συμβουλευτικής με αισθητικό', 'Επιλεγμένες μάρκες', 'Όλες οι μάρκες — μάθετε περισσότερα →', 'Οι θεραπείες μας', 'Ιδέα για δώρο', 'Ειδικά κουπόνια', 'Ιδέα για event', 'Beauty News', 'Τα ινστιτούτα μας'],
    ru: ['Поиск товара или бренда', 'Выберите бренд', 'Все бренды', 'Поиск', 'Выбор по потребности', 'Тип продукта', 'Купить сертификат', 'Подарок на процедуры и косметику', 'Процедуры', 'Все процедуры', 'Главная страница', 'Весь магазин · фильтруй и покупай', '100% оригинальных косметических средств', 'Возможность консультации с косметологом', 'Отобранные бренды', 'Все бренды — узнайте больше →', 'Наши процедуры', 'Идея для подарка', 'Специальные бонусы', 'Идея для мероприятия', 'Новости красоты', 'Наши институты'],
    uk: ['Пошук товару або бренду', 'Оберіть бренд', 'Усі бренди', 'Пошук', 'Вибір за потребою', 'Тип продукту', 'Купити сертифікат', 'Подарунок на процедури та косметику', 'Процедури', 'Усі процедури', 'Головна сторінка', 'Весь магазин · фільтруй і купуй', '100% оригінальних косметичних засобів', 'Можливість консультації з косметологом', 'Ретельно відібрані бренди', 'Усі бренди — дізнатися більше →', 'Наші процедури', 'Ідея для подарунка', 'Спеціальні бонуси', 'Ідея для заходу', 'Beauty News', 'Наші інститути']
  };
  var JEZ = (document.documentElement.lang || 'pl').slice(0, 2).toLowerCase();
  var T = NAPISY[JEZ] || NAPISY.pl;
  var JAD_ROOT = (window.Shopify && Shopify.routes && Shopify.routes.root) || '/';
  function jadSciezka(u) {
    if (!u || JAD_ROOT === '/' || u.charAt(0) !== '/' || u.charAt(1) === '/' || u.indexOf(JAD_ROOT) === 0) return u;
    return JAD_ROOT + u.slice(1);
  }
  (function popraw(o) {
    if (!o || typeof o !== 'object') return;
    Object.keys(o).forEach(function (k) {
      var v = o[k];
      if (typeof v === 'string') { if (k === 'url' || k === 'allUrl' || k === 'brandsUrl') o[k] = jadSciezka(v); }
      else popraw(v);
    });
  })(window.__JADORE_MENU);

  /* Logotypy marek: 39/39 znormalizowanych (jednakowa masa optyczna, staly box 480x128).
     v2m = grafit (spoczynek, ladowany od razu), v2 = kolor (doladowywany przy najechaniu). */
  var LOGO_BASE = 'https://vqggtzmnlrcmjwgmlktr.supabase.co/storage/v1/object/public/vagheggi-images/jadore-derm/logos/';
  var LOGO_MONO = LOGO_BASE + 'v2m/';
  var LOGO_COLOR = LOGO_BASE + 'v2/';

  /* Kolor akcentowy marki (skladowe RGB) -> subtelny wash w tle kafla.
     Zrodlo: kolorowy logotyp, a gdy jest achromatyczny — srodek packshotu.
     '58,52,44' = cieply grafit dla marek bez koloru (Medik8, Dermalogica, Olaplex...). */
  var BRAND_TINT = {
    'authentic-beauty-concept':'114,164,182', 'cell-fusion-c':'185,175,111', 'dermalogica':'58,52,44',
    'dermaquest':'114,131,182', 'dermomedica-1':'180,139,53', 'diego-dalla-palma':'58,52,44',
    'dives-med':'58,52,44', 'dottore':'199,133,97', 'dsd-de-luxe':'174,140,79',
    'estgen':'194,172,102', 'esthederm':'58,52,44', 'image-skincare':'231,145,64',
    'intraceuticals':'33,161,226', 'is-clinical':'17,43,136', 'kevin-murphy':'58,52,44',
    'kv-1':'30,214,227', 'lpg':'198,180,98', 'maroccanoil':'17,136,134',
    'mediderma':'58,52,44', 'medik8':'58,52,44', 'mesoestetic':'182,144,114',
    'minetan':'212,131,84', 'my-skin-chemistry':'81,154,215', 'olaplex':'58,52,44',
    'onmacabim':'198,97,112', 'peel-mission':'178,22,33', 'phformula':'58,52,44',
    'podopharm':'216,80,104', 'pro-xn':'114,151,182', 'purles':'90,48,105',
    'retixc':'215,27,84', 'selvert-thermal':'58,52,44', 'sesderma':'52,75,101',
    'skeyndor':'58,52,44', 'solverx':'22,133,182', 'sunfx':'122,77,41',
    'teoxane':'58,52,44', 'vagheggi':'17,114,136', 'zo-skin-health':'58,52,44'
  };

  /* Marki, ktorych znak graficzny NIE zawiera nazwy (sam sygnet).
     Zamiast dokladac podpis pod logo — co rozpychalo rzad — pokazujemy wordmark. */
  var WORDMARK_ONLY = { 'my-skin-chemistry': 1 };

  function ready(fn) {
    if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', fn);
    else fn();
  }
  function el(tag, cls, text) {
    var n = document.createElement(tag);
    if (cls) n.className = cls;
    if (text != null) n.textContent = text;
    return n;
  }

  ready(function () {
    var DATA = window.__JADORE_MENU;
    if (!DATA || !DATA.groups) return;
    var groups = {};
    DATA.groups.forEach(function (g) { groups[g.key] = g; });

    // ---- kafel (image card) dla zabiegi/bony ----
    function tile(item, cls) {
      var a = el('a', 'jad-tile' + (cls ? ' ' + cls : '') + (item.image ? '' : ' jad-tile--noimg'));
      a.href = item.url || '#';
      if (item.image) a.style.backgroundImage = "url('" + item.image + "')";
      a.appendChild(el('span', 'jad-tile__shade'));
      var cap = el('span', 'jad-tile__cap');
      cap.appendChild(el('b', 'jad-tile__title', String(item.title == null ? '' : item.title)));
      a.appendChild(cap);
      return a;
    }

    // ================= DESKTOP MEGA =================
    var panel = el('div', 'jad-mega');
    panel.setAttribute('role', 'region');
    var inner = el('div', 'jad-mega__inner');
    panel.appendChild(inner);
    document.body.appendChild(panel);
    var closeTimer = null;

    // ---- render: zabiegi / bony (kafle) ----
    function renderCategories(g) {
      panel.classList.remove('jad-mega--brands');
      inner.innerHTML = '';
      var head = el('div', 'jad-mega__head');
      var t = el('span', 'jad-mega__head-title', g.label);
      var all = el('a', 'jad-mega__head-all', 'Zobacz wszystko');
      all.href = g.url || '#';
      head.appendChild(t); head.appendChild(all);
      var grid = el('div', 'jad-mega__grid');
      (g.categories || []).slice(0, 16).forEach(function (c) { grid.appendChild(tile(c)); });
      inner.appendChild(head); inner.appendChild(grid);
    }

    // ---- render: dermokosmetyki (rail + marki + promo) ----
    function renderBrands(g) {
      panel.classList.add('jad-mega--brands');
      inner.innerHTML = '';
      var brands = g.brands || [];
      var areas = g.areas || [{ key: 'wszystkie', label: 'Wszystkie marki' }];
      var wrap = el('div', 'jad-derm');

      /* LEFT RAIL */
      var rail = el('div', 'jad-derm__rail');
      rail.appendChild(el('div', 'jad-derm__eyebrow', 'PIELĘGNACJA'));
      rail.appendChild(el('div', 'jad-derm__title', 'Dermokosmetyki'));
      rail.appendChild(el('div', 'jad-derm__rule'));
      /* okienko „Wszystkie kosmetyki" -> pełna strona sklepu dermokosmetyków */
      var allCosmo = el('a', 'jad-derm__allcosmo');
      allCosmo.href = g.allUrl || jadSciezka('/pages/dermokosmetyki');
      var acTxt = el('span', 'jad-derm__allcosmo-txt');
      acTxt.appendChild(el('b', null, 'Wszystkie kosmetyki'));
      acTxt.appendChild(el('span', 'jad-derm__allcosmo-sub', T[11]));
      allCosmo.appendChild(acTxt);
      allCosmo.appendChild(el('span', 'jad-derm__allcosmo-arr', '→'));
      rail.appendChild(allCosmo);
      rail.appendChild(el('div', 'jad-derm__areas-label', 'OBSZARY PIELĘGNACJI'));
      var areasBox = el('div', 'jad-derm__areas');
      var mainHeadName; // set below
      var gridEl;       // set below
      function applyFilter(key, btn) {
        areasBox.querySelectorAll('.jad-derm__area').forEach(function (b) { b.classList.remove('is-active'); });
        if (btn) btn.classList.add('is-active');
        var shown = 0;
        gridEl.querySelectorAll('.jad-brand').forEach(function (card) {
          var a = card.getAttribute('data-areas') || '';
          var ok = key === 'wszystkie' || a.split(',').indexOf(key) !== -1;
          card.style.display = ok ? '' : 'none';
          if (ok) shown++;
        });
        var lbl = (areas.filter(function (x) { return x.key === key; })[0] || {}).label || 'Wszystkie marki';
        mainHeadName.textContent = lbl + ' — ' + shown + (shown === 1 ? ' marka' : (shown < 5 ? ' marki' : ' marek'));
      }
      areas.forEach(function (ar, i) {
        var b = el('span', 'jad-derm__area' + (i === 0 ? ' is-active' : ''));
        b.appendChild(el('span', 'jad-derm__area-txt', ar.label));
        b.appendChild(el('span', 'jad-derm__area-arrow', '→'));
        b.addEventListener('mouseenter', function () { applyFilter(ar.key, b); });
        b.addEventListener('click', function () { applyFilter(ar.key, b); });
        areasBox.appendChild(b);
      });
      rail.appendChild(areasBox);
      var cnt = el('div', 'jad-derm__count');
      cnt.appendChild(el('span', 'jad-derm__count-num', String(brands.length)));
      cnt.appendChild(el('span', 'jad-derm__count-lbl', 'MAREK\nW OFERCIE'));
      rail.appendChild(cnt);
      var philo = el('a', 'jad-derm__philo', 'POZNAJ NASZĄ FILOZOFIĘ →');
      philo.href = g.brandsUrl || jadSciezka('/pages/marki');
      rail.appendChild(philo);

      /* CENTER — brand grid */
      var main = el('div', 'jad-derm__main');
      var mhead = el('div', 'jad-derm__mainhead');
      mhead.appendChild(el('span', 'jad-derm__mainhead-eyebrow', 'WYBIERZ MARKĘ'));
      mainHeadName = el('span', 'jad-derm__mainhead-active', 'Wszystkie marki — ' + brands.length + ' marek');
      mhead.appendChild(mainHeadName);
      gridEl = el('div', 'jad-derm__grid');
      brands.forEach(function (br) {
        var a = el('a', 'jad-brand');
        a.href = br.url || '#';
        a.setAttribute('data-areas', br.areas || '');
        a.setAttribute('aria-label', br.name || '');
        a.style.setProperty('--brand-rgb', BRAND_TINT[br.handle] || '58,52,44');

        var media = el('span', 'jad-brand__media');
        if (WORDMARK_ONLY[br.handle]) {
          media.classList.add('jad-brand__media--wm');
          media.appendChild(el('span', 'jad-brand__wm', br.name || ''));
          a.appendChild(media);
          a.addEventListener('mouseenter', function () { mainHeadName.textContent = br.name; });
          gridEl.appendChild(a);
          return;
        }
        var mono = el('img', 'jad-brand__logo jad-brand__logo--mono');
        mono.src = LOGO_MONO + br.handle + '.png';
        mono.alt = br.name || '';
        mono.loading = 'lazy';
        mono.width = 480; mono.height = 128;
        /* brak pliku logo -> elegancki wordmark zamiast pustego kafla */
        mono.addEventListener('error', function () {
          media.classList.add('jad-brand__media--wm');
          while (media.firstChild) media.removeChild(media.firstChild);
          media.appendChild(el('span', 'jad-brand__wm', br.name || ''));
        });
        var color = el('img', 'jad-brand__logo jad-brand__logo--color');
        color.alt = '';
        color.setAttribute('aria-hidden', 'true');
        color.setAttribute('data-src', LOGO_COLOR + br.handle + '.png');
        media.appendChild(mono);
        media.appendChild(color);

        a.appendChild(media);
        /* logotyp niesie juz nazwe marki — zadnego podpisu pod spodem */
        a.addEventListener('mouseenter', function () {
          mainHeadName.textContent = br.name;
          var src = color.getAttribute('data-src');
          if (src && !color.getAttribute('src')) color.setAttribute('src', src);
        });
        gridEl.appendChild(a);
      });
      main.appendChild(mhead); main.appendChild(gridEl);

      wrap.appendChild(rail); wrap.appendChild(main);
      panel.classList.remove('jad-mega--haspromo');
      inner.appendChild(wrap);

      /* value props strip */
      var props = el('div', 'jad-derm__props');
      [T[12], T[13], T[14]].forEach(function (txt) {
        var pr = el('span', 'jad-derm__prop');
        pr.appendChild(el('span', 'jad-derm__prop-ico', '✓'));
        pr.appendChild(el('span', null, txt));
        props.appendChild(pr);
      });
      inner.appendChild(props);
    }

    function renderPanel(key) {
      var g = groups[key];
      if (!g) return false;
      if (key === 'dermokosmetyki') {
        if (!(g.brands || []).length) return false;
        renderBrands(g);
        return true;
      }
      if (!(g.categories || []).length) return false;
      renderCategories(g);
      return true;
    }

    function positionPanel() {
      var h = document.querySelector('.header__wrapper, .shopify-section-header, .header, header');
      var top = 64;
      if (h) { var r = h.getBoundingClientRect(); top = Math.max(0, r.bottom); }
      panel.style.setProperty('--jad-mega-top', top + 'px');
    }
    function openPanel(key) {
      clearTimeout(closeTimer);
      if (!renderPanel(key)) { closePanel(); return; }
      positionPanel();
      panel.classList.add('is-open');
      document.documentElement.classList.add('jad-mega-on');
    }
    function closePanel() {
      closeTimer = setTimeout(function () {
        panel.classList.remove('is-open');
        document.documentElement.classList.remove('jad-mega-on');
      }, 140);
    }
    panel.addEventListener('mouseenter', function () { clearTimeout(closeTimer); });
    panel.addEventListener('mouseleave', closePanel);
    document.addEventListener('keydown', function (e) {
      if (e.key === 'Escape') { panel.classList.remove('is-open'); document.documentElement.classList.remove('jad-mega-on'); }
    });

    var keyByText = [
      { rx: /dermokosmetyk/i, key: 'dermokosmetyki' },
      { rx: /\bbony\b|prezentow/i, key: 'bony' },
      { rx: /zabieg/i, key: 'zabiegi' }
    ];
    function matchKey(txt) {
      for (var i = 0; i < keyByText.length; i++) if (keyByText[i].rx.test(txt)) return keyByText[i].key;
      return null;
    }
    document.querySelectorAll('.header__menu > ul > li').forEach(function (li) {
      var link = li.querySelector('a.menu__item, summary, a');
      if (!link) return;
      var key = matchKey(link.textContent || '');
      if (!key || !groups[key]) return;
      var g = groups[key];
      if (key === 'dermokosmetyki' ? !(g.brands || []).length : !(g.categories || []).length) return;
      li.classList.add('jad-has-mega');
      li.addEventListener('mouseenter', function () { openPanel(key); });
      li.addEventListener('mouseleave', function () { closePanel(); });
      link.addEventListener('focus', function () { openPanel(key); });
    });

    // ================= MOBILE / DRAWER =================
    var drawer = el('div', 'jad-drawer');
    var overlay = el('div', 'jad-drawer__overlay');
    var aside = el('aside', 'jad-drawer__panel');
    aside.setAttribute('role', 'dialog'); aside.setAttribute('aria-label', 'Menu');
    var top = el('div', 'jad-drawer__top');
    top.appendChild(el('span', 'jad-drawer__brand', 'Menu'));
    var closeBtn = el('button', 'jad-drawer__close', '×');
    closeBtn.setAttribute('aria-label', 'Zamknij');
    top.appendChild(closeBtn);
    var body = el('div', 'jad-drawer__body');
    aside.appendChild(top); aside.appendChild(body);
    drawer.appendChild(overlay); drawer.appendChild(aside);
    document.body.appendChild(drawer);

    // — widok glowny drawera —
    var homeView = el('div', 'jad-drawer__view');
    // Native Shopify form keeps country and language explicit; no automatic market switch.
    var localizationTemplate = document.getElementById('JadDrawerLocalization');
    if (localizationTemplate && localizationTemplate.content) {
      homeView.appendChild(localizationTemplate.content.cloneNode(true));
    }

    // — 19.09.2026: szuflada zaczyna sie od szukajki i wyboru marki —
    // Sklep sprzedaje marki, a marki byly dopiero za kaflem "Dermokosmetyki", pod zdjeciami
    // zabiegow. Teraz na gorze: pole wyszukiwania i 12 pierwszych marek z jadore-brands-list.
    // Kolejnosc napisow: 0 placeholder szukajki, 1 "Wybierz marke", 2 "Wszystkie marki",
    // 3 "Szukaj", 4 "Wybierz po potrzebie", 5 "Rodzaj produktu", 6 "Kup bon",
    // 7 podpis bonu, 8 "Zabiegi", 9 "Wszystkie zabiegi", 10 "Strona glowna".

    var sForm = el('form', 'jad-drawer__search');
    sForm.action = ((window.Shopify && Shopify.routes && Shopify.routes.root) || '/') + 'search';
    sForm.method = 'get';
    sForm.setAttribute('role', 'search');
    var sInput = el('input');
    sInput.type = 'search'; sInput.name = 'q'; sInput.placeholder = T[0];
    sInput.setAttribute('aria-label', T[0]);
    sInput.setAttribute('autocomplete', 'off');
    sInput.setAttribute('enterkeyhint', 'search');
    var sType = el('input');
    sType.type = 'hidden'; sType.name = 'options[prefix]'; sType.value = 'last';
    var sBtn = el('button', 'jad-drawer__search-btn');
    sBtn.type = 'submit';
    sBtn.setAttribute('aria-label', T[3]);
    sBtn.innerHTML = '<svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.8" stroke-linecap="round" aria-hidden="true"><circle cx="11" cy="11" r="7"/><path d="m20 20-3.5-3.5"/></svg>';
    sForm.appendChild(sInput); sForm.appendChild(sType); sForm.appendChild(sBtn);
    homeView.appendChild(sForm);

    var topBrands = ((groups['dermokosmetyki'] || {}).brands || []);
    if (topBrands.length) {
      homeView.appendChild(el('div', 'jad-drawer__label', T[1]));
      var bGrid = el('div', 'jad-drawer__brandgrid');
      topBrands.slice(0, 12).forEach(function (br) {
        var cell = el('a', 'jad-drawer__bcell');
        cell.href = br.url || '#';
        cell.setAttribute('aria-label', br.name || '');
        if (WORDMARK_ONLY[br.handle]) {
          cell.appendChild(el('span', 'jad-drawer__bcell-word', br.name || ''));
          bGrid.appendChild(cell);
          return;
        }
        var logo = el('img', 'jad-drawer__bcell-logo');
        logo.src = LOGO_COLOR + br.handle + '.png';
        logo.alt = ''; logo.loading = 'lazy'; logo.decoding = 'async';
        /* brak pliku logo (np. nowe marki) -> nazwa marki jako napis, nie pusta ramka */
        logo.addEventListener('error', function () {
          if (logo.parentNode) logo.parentNode.removeChild(logo);
          cell.appendChild(el('span', 'jad-drawer__bcell-word', br.name || ''));
        });
        cell.appendChild(logo);
        bGrid.appendChild(cell);
      });
      homeView.appendChild(bGrid);
      var moreBrands = el('button', 'jad-drawer__morebrands');
      moreBrands.type = 'button';
      moreBrands.appendChild(el('span', null, T[2] + ' (' + topBrands.length + ')'));
      moreBrands.appendChild(el('span', 'jad-drawer__morebrands-arr', '→'));
      moreBrands.addEventListener('click', function () { showBrandsView(); });
      homeView.appendChild(moreBrands);
    }

    // — 20.09.2026: kolejnosc szuflady wg AG — marki, zaraz potem wybor "po tagach",
    //   dalej bon, a na koncu zabiegi i powrot na strone glowna.
    //   Chipy prowadza do istniejacych kolekcji sklepu (potrzeba-* i rodzaje produktu);
    //   liczby produktow sprawdzone 20.09.2026, najmniejsza kolekcja ma 21 pozycji.
    var KORZEN = ((window.Shopify && Shopify.routes && Shopify.routes.root) || '/');
    /* Adresy z danych menu sa bez przedrostka jezyka (`/pages/bony`), wiec na /en/... wiodly
       na polska wersje. Sciezki wewnetrzne przepuszczamy przez korzen sklepu. */
    function sciezka(u) {
      if (!u || KORZEN === '/') return u || '#';
      if (u.charAt(0) !== '/' || u.indexOf(KORZEN) === 0) return u;
      return KORZEN + u.replace(/^\//, '');
    }
    var POTRZEBY = [
      { h: 'potrzeba-nawilzenie', pl: 'Nawilżenie', en: 'Hydration' },
      { h: 'potrzeba-antiage', pl: 'Zmarszczki i anti-age', en: 'Wrinkles & anti-age' },
      { h: 'potrzeba-przebarwienia', pl: 'Przebarwienia', en: 'Dark spots' },
      { h: 'potrzeba-tradzik', pl: 'Trądzik', en: 'Acne' },
      { h: 'potrzeba-naczynka', pl: 'Naczynka i rumień', en: 'Redness' },
      { h: 'potrzeba-kojenie', pl: 'Cera wrażliwa', en: 'Sensitive skin' },
      { h: 'potrzeba-sebum', pl: 'Matowienie', en: 'Mattifying' },
      { h: 'potrzeba-rozswietlenie', pl: 'Rozświetlenie', en: 'Radiance' },
      { h: 'potrzeba-ujedrnianie', pl: 'Ujędrnianie', en: 'Firming' },
      { h: 'potrzeba-uv', pl: 'Ochrona SPF', en: 'SPF protection' },
      { h: 'potrzeba-wypadanie', pl: 'Wypadanie włosów', en: 'Hair loss' },
      { h: 'potrzeba-wlosy-suche', pl: 'Włosy suche', en: 'Dry hair' }
    ];
    var RODZAJE = [
      { h: 'twarz-serum', pl: 'Serum', en: 'Serums' },
      { h: 'twarz-kremy', pl: 'Kremy', en: 'Creams' },
      { h: 'twarz-pod-oczy', pl: 'Pod oczy', en: 'Eye care' },
      { h: 'twarz-maski', pl: 'Maski', en: 'Masks' },
      { h: 'twarz-peelingi', pl: 'Peelingi', en: 'Exfoliants' },
      { h: 'twarz-oczyszczanie', pl: 'Oczyszczanie', en: 'Cleansing' },
      { h: 'twarz-spf', pl: 'Kremy z SPF', en: 'SPF creams' },
      { h: 'dermokosmetyki-cialo', pl: 'Ciało', en: 'Body' },
      { h: 'dermokosmetyki-wlosy', pl: 'Włosy', en: 'Hair' }
    ];
    // Etykiety chipow w 13 jezykach - z scripts/shopify-theme/napisy_motywu_tlumaczenia.json (DeepSeek).
    var ETYKIETY = {
      'potrzeba-nawilzenie': { en: 'Hydration', de: 'Feuchtigkeitsversorgung', es: 'Hidratación', fr: 'Hydratation', it: 'Idratazione', nl: 'Hydratatie', pt: 'Hidratação', sv: 'Återfuktning', nb: 'Fuktighet', el: 'Ενυδάτωση', ru: 'Увлажнение', uk: 'Зволоження' },
      'potrzeba-antiage': { en: 'Wrinkles & anti-age', de: 'Falten und Anti-Age', es: 'Arrugas y anti-edad', fr: 'Rides et anti-âge', it: 'Rughe e anti-age', nl: 'Rimpels en anti-age', pt: 'Rugas e anti-idade', sv: 'Rynkor och anti-age', nb: 'Rynker og anti-age', el: 'Ρυτίδες και anti-age', ru: 'Морщины и anti-age', uk: 'Зморшки та anti-age' },
      'potrzeba-przebarwienia': { en: 'Dark spots', de: 'Hyperpigmentierung', es: 'Hiperpigmentación', fr: 'Hyperpigmentation', it: 'Discromie', nl: 'Pigmentvlekken', pt: 'Hiperpigmentação', sv: 'Pigmentfläckar', nb: 'Hyperpigmentering', el: 'Υπερχρωματισμοί', ru: 'Пигментация', uk: 'Пігментація' },
      'potrzeba-tradzik': { en: 'Acne', de: 'Akne', es: 'Acné', fr: 'Acné', it: 'Acne', nl: 'Acne', pt: 'Acne', sv: 'Akne', nb: 'Akne', el: 'Ακμή', ru: 'Акне', uk: 'Акне' },
      'potrzeba-naczynka': { en: 'Redness', de: 'Äderchen und Rötung', es: 'Capilares y rojeces', fr: 'Vaisseaux et rougeurs', it: 'Couperose e rossore', nl: 'Haarvaten en roodheid', pt: 'Capilares e vermelhidão', sv: 'Kapillärer och rodnad', nb: 'Blodårer og rødhet', el: 'Αγγεία και ερυθρότητα', ru: 'Сосуды и покраснения', uk: 'Судини та почервоніння' },
      'potrzeba-kojenie': { en: 'Sensitive skin', de: 'Empfindliche Haut', es: 'Piel sensible', fr: 'Peau sensible', it: 'Pelle sensibile', nl: 'Gevoelige huid', pt: 'Pele sensível', sv: 'Känslig hud', nb: 'Sensitiv hud', el: 'Ευαίσθητη επιδερμίδα', ru: 'Чувствительная кожа', uk: 'Чутлива шкіра' },
      'potrzeba-sebum': { en: 'Mattifying', de: 'Mattierung', es: 'Matificación', fr: 'Matification', it: 'Opacizzante', nl: 'Mattheid', pt: 'Matificação', sv: 'Mattifiering', nb: 'Mattifiering', el: 'Ματ εφέ', ru: 'Матирование', uk: 'Матування' },
      'potrzeba-rozswietlenie': { en: 'Radiance', de: 'Ausleuchtung', es: 'Iluminación', fr: 'Éclat', it: 'Illuminazione', nl: 'Verheldering', pt: 'Iluminação', sv: 'Lyster', nb: 'Opplysning', el: 'Λάμψη', ru: 'Сияние', uk: 'Сяйво' },
      'potrzeba-ujedrnianie': { en: 'Firming', de: 'Straffung', es: 'Reafirmación', fr: 'Fermeté', it: 'Rassodamento', nl: 'Versteviging', pt: 'Firmeza', sv: 'Fasthet', nb: 'Stramming', el: 'Σύσφιξη', ru: 'Подтяжка', uk: 'Підтягування' },
      'potrzeba-uv': { en: 'SPF protection', de: 'SPF-Schutz', es: 'Protección SPF', fr: 'Protection SPF', it: 'Protezione SPF', nl: 'SPF-bescherming', pt: 'Proteção SPF', sv: 'SPF-skydd', nb: 'SPF-beskyttelse', el: 'Προστασία SPF', ru: 'Защита SPF', uk: 'Захист SPF' },
      'potrzeba-wypadanie': { en: 'Hair loss', de: 'Haarausfall', es: 'Caída del cabello', fr: 'Chute de cheveux', it: 'Caduta dei capelli', nl: 'Haaruitval', pt: 'Queda de cabelo', sv: 'Håravfall', nb: 'Hårtap', el: 'Τριχόπτωση', ru: 'Выпадение волос', uk: 'Випадіння волосся' },
      'potrzeba-wlosy-suche': { en: 'Dry hair', de: 'Trockenes Haar', es: 'Cabello seco', fr: 'Cheveux secs', it: 'Capelli secchi', nl: 'Droog haar', pt: 'Cabelo seco', sv: 'Torrt hår', nb: 'Tørt hår', el: 'Ξηρά μαλλιά', ru: 'Сухие волосы', uk: 'Сухе волосся' },
      'twarz-serum': { en: 'Serums', de: 'Serum', es: 'Sérum', fr: 'Sérum', it: 'Siero', nl: 'Serum', pt: 'Sérum', sv: 'Serum', nb: 'Serum', el: 'Ορός', ru: 'Сыворотка', uk: 'Сироватка' },
      'twarz-kremy': { en: 'Creams', de: 'Cremes', es: 'Cremas', fr: 'Crèmes', it: 'Crema', nl: 'Crèmes', pt: 'Cremes', sv: 'Krämer', nb: 'Kremer', el: 'Κρέμες', ru: 'Кремы', uk: 'Креми' },
      'twarz-pod-oczy': { en: 'Eye care', de: 'Für die Augenpartie', es: 'Contorno de ojos', fr: 'Contour des yeux', it: 'Contorno occhi', nl: 'Voor onder de ogen', pt: 'Contorno de olhos', sv: 'Under ögonen', nb: 'Under øynene', el: 'Για την περιοχή των ματιών', ru: 'Под глаза', uk: 'Під очі' },
      'twarz-maski': { en: 'Masks', de: 'Masken', es: 'Mascarillas', fr: 'Masques', it: 'Maschere', nl: 'Maskers', pt: 'Máscaras', sv: 'Masker', nb: 'Masker', el: 'Μάσκες', ru: 'Маски', uk: 'Маски' },
      'twarz-peelingi': { en: 'Exfoliants', de: 'Peelings', es: 'Peelings', fr: 'Peelings', it: 'Peeling', nl: 'Peelings', pt: 'Peelings', sv: 'Peelingar', nb: 'Peelinger', el: 'Απολεπίσεις', ru: 'Пилинги', uk: 'Пілінги' },
      'twarz-oczyszczanie': { en: 'Cleansing', de: 'Reinigung', es: 'Limpieza', fr: 'Nettoyage', it: 'Detersione', nl: 'Reiniging', pt: 'Limpeza', sv: 'Rengöring', nb: 'Rengjøring', el: 'Καθαρισμός', ru: 'Очищение', uk: 'Очищення' },
      'twarz-spf': { en: 'SPF creams', de: 'Cremes mit SPF', es: 'Cremas con SPF', fr: 'Crèmes avec SPF', it: 'Crema con SPF', nl: 'Crèmes met SPF', pt: 'Cremes com SPF', sv: 'Krämer med SPF', nb: 'Kremer med SPF', el: 'Κρέμες με SPF', ru: 'Кремы с SPF', uk: 'Креми з SPF' },
      'dermokosmetyki-cialo': { en: 'Body', de: 'Körper', es: 'Cuerpo', fr: 'Corps', it: 'Corpo', nl: 'Lichaam', pt: 'Corpo', sv: 'Kropp', nb: 'Kropp', el: 'Σώμα', ru: 'Тело', uk: 'Тіло' },
      'dermokosmetyki-wlosy': { en: 'Hair', de: 'Haare', es: 'Cabello', fr: 'Cheveux', it: 'Capelli', nl: 'Haar', pt: 'Cabelo', sv: 'Hår', nb: 'Hår', el: 'Μαλλιά', ru: 'Волосы', uk: 'Волосся' }
    };
    function chipy(lista, etykieta) {
      homeView.appendChild(el('div', 'jad-drawer__label', etykieta));
      var box = el('div', 'jad-drawer__tags');
      lista.forEach(function (p) {
        var a = el('a', 'jad-drawer__tag', JEZ === 'pl' ? p.pl : ((ETYKIETY[p.h] && ETYKIETY[p.h][JEZ]) || p.en));
        a.href = KORZEN + 'collections/' + p.h;
        box.appendChild(a);
      });
      homeView.appendChild(box);
    }
    chipy(POTRZEBY, T[4]);
    chipy(RODZAJE, T[5]);

    // — bon: osobny, wyrozniony przycisk (wczesniej kafel "Bony" w rzedzie czterech) —
    var bonG = groups['bony'] || {};
    var bon = el('a', 'jad-drawer__bon');
    bon.href = sciezka(bonG.url || '/pages/bony');
    var bonTxt = el('span', 'jad-drawer__bon-txt');
    bonTxt.appendChild(el('b', null, T[6]));
    bonTxt.appendChild(el('span', 'jad-drawer__bon-sub', T[7]));
    bon.appendChild(bonTxt);
    bon.appendChild(el('span', 'jad-drawer__bon-arr', '→'));
    homeView.appendChild(bon);

    homeView.appendChild(el('div', 'jad-drawer__label', T[8]));
    var favs = el('div', 'jad-drawer__favs');
    var zab = groups['zabiegi'];
    if (zab && zab.categories) zab.categories.slice(0, 4).forEach(function (c) { favs.appendChild(tile(c, 'jad-tile--sm')); });
    homeView.appendChild(favs);

    // — powrot: wszystkie zabiegi i strona glowna —
    var wroc = el('div', 'jad-drawer__back-rows');
    [
      { t: T[9], u: sciezka((zab && zab.url) || '/collections/medycyna-estetyczna') },
      { t: T[10], u: KORZEN }
    ].forEach(function (r) {
      var a = el('a', 'jad-drawer__back-row');
      a.href = r.u;
      a.appendChild(el('span', null, r.t));
      a.appendChild(el('span', 'jad-drawer__back-row-arr', '→'));
      wroc.appendChild(a);
    });
    homeView.appendChild(wroc);

    // — J'ADORE INSTYTUT — te same pozycje co w poziomym menu naglowka.
    // Ponizej 1280px poziome menu jest ukryte (patrz jadore-header-canon.css),
    // wiec bez tej sekcji szuflada nie dawala zadnego dojscia na strone marki.
    var jadSec = el('div', 'jad-drawer__site');
    jadSec.appendChild(el('div', 'jad-drawer__site-head', "J'ADORE INSTYTUT"));
    // Strona instytutu ma tylko wersje pl i en - dla pozostalych jezykow prowadzimy na /en.
    var JAD_SITE = JEZ === 'pl' ? 'https://jadoreinstytut.com' : 'https://jadoreinstytut.com/en';
    [
      { t: T[16], u: JAD_SITE + '/zabiegi' },
      { t: T[17], u: JAD_SITE + '/prezenty' },
      { t: T[18], u: JAD_SITE + '/bony-specjalne' },
      { t: T[19], u: JAD_SITE + '/eventy' },
      { t: T[20], u: JAD_SITE + '/blog' },
      { t: T[21], u: JAD_SITE + '/kontakt' }
    ].forEach(function (s) {
      var sa = el('a', 'jad-drawer__site-link', s.t);
      sa.href = s.u;
      jadSec.appendChild(sa);
    });
    homeView.appendChild(jadSec);
    body.appendChild(homeView);

    // — widok marek (dermokosmetyki) —
    var brandsView = el('div', 'jad-drawer__view jad-drawer__view--brands');
    brandsView.style.display = 'none';
    var back = el('button', 'jad-drawer__back', '← Menu');
    brandsView.appendChild(back);
    var dg = groups['dermokosmetyki'] || {};
    var mAllCosmo = el('a', 'jad-drawer__allcosmo');
    mAllCosmo.href = dg.allUrl || jadSciezka('/pages/dermokosmetyki');
    mAllCosmo.appendChild(el('b', null, 'Wszystkie kosmetyki'));
    mAllCosmo.appendChild(el('span', 'jad-drawer__allcosmo-arr', '→'));
    brandsView.appendChild(mAllCosmo);
    brandsView.appendChild(el('div', 'jad-drawer__label', 'Dermokosmetyki — obszary'));
    var mChips = el('div', 'jad-drawer__chips');
    var mList = el('div', 'jad-drawer__brands');
    var dBrands = dg.brands || [];
    (dg.areas || []).forEach(function (ar, i) {
      var c = el('span', 'jad-drawer__chip' + (i === 0 ? ' is-active' : ''), ar.label);
      c.addEventListener('click', function () {
        mChips.querySelectorAll('.jad-drawer__chip').forEach(function (x) { x.classList.remove('is-active'); });
        c.classList.add('is-active');
        mList.querySelectorAll('.jad-drawer__brand').forEach(function (row) {
          var a = row.getAttribute('data-areas') || '';
          row.style.display = (ar.key === 'wszystkie' || a.split(',').indexOf(ar.key) !== -1) ? '' : 'none';
        });
      });
      mChips.appendChild(c);
    });
    dBrands.forEach(function (br) {
      var a = el('a', 'jad-drawer__brand');
      a.href = br.url || '#';
      a.setAttribute('data-areas', br.areas || '');
      /* na dotyku nie ma hoveru — logo od razu w kolorze, inaczej marka jest nieczytelna */
      var badge = el('span', 'jad-drawer__brand-badge');
      var blogo = el('img', 'jad-drawer__brand-logo');
      blogo.src = LOGO_COLOR + br.handle + '.png';
      blogo.alt = ''; blogo.setAttribute('aria-hidden', 'true'); blogo.loading = 'lazy';
      /* brak pliku logo -> nazwa marki napisem (wczesniej sama litera w kolku: "H", "P", "B") */
      blogo.addEventListener('error', function () {
        badge.classList.add('jad-drawer__brand-badge--word');
        while (badge.firstChild) badge.removeChild(badge.firstChild);
        badge.textContent = br.name || br.initial || '?';
      });
      badge.appendChild(blogo);
      a.appendChild(badge);
      a.appendChild(el('span', 'jad-drawer__brand-name', br.name || ''));
      a.appendChild(el('span', 'jad-drawer__brand-arrow', '→'));
      mList.appendChild(a);
    });
    brandsView.appendChild(mChips);
    brandsView.appendChild(mList);
    var allBtn = el('a', 'jad-drawer__allbrands', T[15]);
    allBtn.href = dg.brandsUrl || jadSciezka('/pages/marki');
    brandsView.appendChild(allBtn);
    body.appendChild(brandsView);

    function showBrandsView() { homeView.style.display = 'none'; brandsView.style.display = 'block'; body.scrollTop = 0; }
    function showHomeView() { brandsView.style.display = 'none'; homeView.style.display = 'block'; }
    back.addEventListener('click', showHomeView);

    function openDrawer() { drawer.classList.add('is-open'); document.documentElement.classList.add('jad-noscroll'); showHomeView(); }
    function closeDrawer() { drawer.classList.remove('is-open'); document.documentElement.classList.remove('jad-noscroll'); }
    overlay.addEventListener('click', closeDrawer);
    closeBtn.addEventListener('click', closeDrawer);
    document.addEventListener('keydown', function (e) { if (e.key === 'Escape') closeDrawer(); });

    if (!document.querySelector('.jad-drawer-trigger')) {
      var btn = el('button', 'jad-drawer-trigger');
      btn.setAttribute('aria-label', "Menu J'ADORE");
      btn.appendChild(el('span', 'jad-drawer-trigger__ico', '☰'));
      btn.appendChild(el('span', null, 'Menu'));
      btn.addEventListener('click', openDrawer);
      var host = document.querySelector('.menu-drawer-button') || document.querySelector('.header__icons--left') || document.querySelector('.header__wrapper');
      if (host && host.parentNode) host.parentNode.insertBefore(btn, host);
      else document.body.appendChild(btn);
    }
  });
})();
